import Storage from "../storage";

export const setActiveTab = (tabName)=>{
	loading();
	Storage.dispatch({
		type : 'SET ACTIVE TAB',
		tabName : tabName
	});
	incrementVideoVersion();
}

export const loading = (enable = true)=>{
	Storage.dispatch({
		type : 'LOADING',
		status : enable
		// status : enable
	});
}
export const incrementVideoVersion = ()=>{
	Storage.dispatch({
		type : 'UPDATE VIDEO VERSION'
	});
}
